import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import laptop from './laptop.png';
import Logo from '../HEADER/logo.png';
import Main from '../MAIN/main';

const GsapLaptopScreen = () => {
  const laptopRef = useRef(null);
  const logoRef = useRef(null);
  const contentRef = useRef(null);

  const [showLaptop, setShowLaptop] = useState(true);
  const [showLogo, setShowLogo] = useState(false);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const tl = gsap.timeline();

    // Step 1: Zoom in laptop image
    tl.fromTo(
      laptopRef.current,
      { scale: 1, opacity: 1 },
      {
        scale: 8, // changed from 4 → avoid overflow
        duration: 1,
        ease: 'power2.inOut',
        transformOrigin: 'center center',
      }
    )
      .to(laptopRef.current, {
        opacity: 0,
        duration: 0.5,
        ease: 'power1.inOut',
        onComplete: () => {
          setShowLaptop(false);
          setShowLogo(true); // logo comes only after laptop is removed
        },
      })

      // Step 2: Logo appears
      .add(() => {
        gsap.fromTo(
          logoRef.current,
          { opacity: 0, scale: 0.5 },
          {
            opacity: 1,
            scale: 1,
            duration: 3,
            ease: 'ease1.inOut',
          }
        );
      }, "+=0.5") // short delay after laptop removal

      // Step 3: Logo disappears
      .add(() => {
        gsap.to(logoRef.current, {
          opacity: 0,
          scale: 1,
          duration: 2,
          ease: 'ease1.inOut',
          onComplete: () => {
            setShowLogo(false);
            setTimeout(() => setShowContent(true), 1000); // wait 1s before content
          },
        });
      }, "+=1.5"); // delay before logo hides
  }, []);

  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-white relative">

      {/* Laptop Image */}
      {showLaptop && (
        <div className="flex justify-center items-center w-full h-full overflow-hidden">
          <img
            ref={laptopRef}
            src={laptop}
            alt="laptop"
            className="w-auto h-auto max-h-[80vh] transition-transform duration-1000 ease-in-out"
          />
        </div>
      )}

      {/* Logo - only shows after laptop is gone */}
      {showLogo && (
        <div className="flex justify-center items-center w-full h-full">
          <img
            ref={logoRef}
            src={Logo}
            alt="Logo"
            className="w-[300px] h-auto opacity-0"
          />
        </div>
      )}

      {/* Final Website Content */}
      {showContent && (
        <div
          ref={contentRef}
          className="flex justify-center items-center text-4xl font-bold text-center"
        >
          <Main/>
        </div>
      )}
    </div>
  );
};

export default GsapLaptopScreen;
